module.exports = __webpack_public_path__ + "media/images/icons/outlined/red-envelope-0980ab473c64326b5486d10e9f8a19e5.svg";